import { FunctionComponent, useCallback } from 'react'
import { WidgetProps } from '@rjsf/core'
import { Checkbox } from '@dxp-module/common'

const CheckboxWidget: FunctionComponent<WidgetProps> = props => {
  const { id, value, onChange, title, label } = props

  const handleChange = useCallback(
    (newValue: boolean) => {
      onChange(newValue)
    },
    [onChange]
  )

  return (
    <Checkbox
      id={id}
      label={title || label}
      onChange={handleChange}
      value={value}
    />
  )
}

export default CheckboxWidget
